import React, { useMemo } from 'react';
import FaTrash from 'react-icons/lib/fa/trash';
import DownloadIcon from 'react-icons/lib/md/file-download';
import MdImage from 'react-icons/lib/md/image';
import MdGraph from 'react-icons/lib/md/insert-chart';
import MdLock from 'react-icons/lib/md/lock';
import { browserHistory } from 'react-router';

import {
  faCode,
  faCut,
  faEllipsisH,
  faTrash,
  faTag,
  faExchangeAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { MEDIA_STATUS } from 'src/common/types/media';
import DropDown from 'src/misc/dropdown/DropDown';

import './video-footer-component.css';

export const VideoFooterComponent = ({
  cancelVideo,
  expired,
  handleEditLabelsClick,
  handlePrivacyClick,
  handleReplaceClick,
  shouldExposeVideoPrivacyChange,
  toggleDeleteModal,
  toggleEmbedModal,
  toggleFileListModal,
  video,
}) => {
  const dropdownItems = useMemo(() => {
    return [
      {
        onClick: () => {
          browserHistory.push(`/stats/${video.shortcode}`);
        },
        icon: <MdGraph />,
        title: 'Analytics',
      },
      {
        onClick: () => {
          browserHistory.push(`/thumbnail/${video.shortcode}`);
        },
        icon: <MdImage />,
        title: 'Edit Thumbnail',
      },
      handleEditLabelsClick
        ? {
            onClick: () => {
              handleEditLabelsClick(video.shortcode);
            },
            icon: <FontAwesomeIcon icon={faTag} />,
            title: 'Edit Labels',
          }
        : null,
      {
        onClick: () => {
          handlePrivacyClick(shouldExposeVideoPrivacyChange);
        },
        icon: <MdLock />,
        title: 'Privacy',
      },
      {
        onClick: () => {
          handleReplaceClick(video.shortcode);
        },
        icon: <FontAwesomeIcon icon={faExchangeAlt} fontVariant="light" />,
        title: 'Replace video',
      },
      {
        onClick: () => {
          toggleFileListModal();
        },
        icon: <DownloadIcon />,
        title: 'Download Links',
      },
      {
        separator: true,
      },
      {
        onClick: () => {
          toggleDeleteModal();
        },
        icon: <FaTrash />,
        title: 'Delete',
      },
    ].filter(Boolean);
  }, [
    handleEditLabelsClick,
    handlePrivacyClick,
    toggleDeleteModal,
    toggleFileListModal,
    shouldExposeVideoPrivacyChange,
  ]);

  return (
    <div
      className={classnames('video-footer', {
        'cursor-not-allowed': expired,
      })}
    >
      <div
        className={classnames('video-footer__actions-container', {
          'video-footer__disabled': expired || !video.shortcode,
        })}
      >
        {video.status === MEDIA_STATUS.READY && (
          <button
            className="action-button"
            onClick={() => toggleEmbedModal(video)}
          >
            <FontAwesomeIcon icon={faCode} /> Embed
          </button>
        )}

        {video.status === null || video.status < MEDIA_STATUS.READY ? (
          <button className="action-button rightmost" onClick={cancelVideo}>
            <FontAwesomeIcon icon={faTrash} /> Cancel
          </button>
        ) : (
          <button
            className="action-button"
            onClick={() => {
              browserHistory.push(`/edit/${video.shortcode}`);
            }}
          >
            <FontAwesomeIcon icon={faCut} fontVariant="light" /> Edit Video
          </button>
        )}
        {video.status === MEDIA_STATUS.READY && (
          <DropDown
            position="bottom left"
            className="action-button rightmost"
            items={dropdownItems}
          >
            <FontAwesomeIcon icon={faEllipsisH} /> More
          </DropDown>
        )}
      </div>
    </div>
  );
};
